import { SignatureOrderUser } from '../../types/taskForm';

export const getDraggableId = (signer: SignatureOrderUser): string => {
  if (signer.id != null) {
    return signer.id.toString();
  }
  if (signer.question_id != null) {
    return `q_${signer.question_id}`;
  }
  return 'unknown';
};

export const generateGroupId = (signers: SignatureOrderUser[]): string => {
  return signers.map((signer) => signer.id.toString()).join('-');
};
